import type { PublicState } from '../../shared/protocol';
import { babelLang, bt } from '../../shared/babel/strings';
import { formatCountdown } from '../util/format';
import { useServerClock } from '../util/clock';

/** v5.5 §6: a glanceable STOP for the Hold-Up curse — v15 BOLT-054 makes it
 *  literal: Hold-Up IS the movement freeze (cards still allowed; the rail no
 *  longer locks for it). Prominent but NON-MODAL on purpose: it dims the top
 *  of the screen but leaves the map and the countdown visible (a full-screen
 *  blocker is unsafe for a moving seeker). Only the seeker sees it, and only
 *  for `holdup`; every other curse keeps the modest CurseBanner. */
export function StopBanner({ state }: { state: PublicState }) {
  const now = useServerClock(state.timer.serverNow, [state.activeCurse?.endsAt]);
  const c = state.activeCurse;
  if (state.you.role !== 'seeker' || !c || c.kind !== 'holdup') return null;
  const left = Math.max(0, c.endsAt - now());
  return (
    <div className="stop-curse" data-testid="stop-banner" role="alert">
      <div className="stop-curse__sign">
        {/* v17 BOLT-077 §2: ONE sub-line, both platforms — the babel table
            is the single source (English when no Babel is up). */}
        <span className="stop-curse__word">{bt(babelLang(state), 'stop')}</span>
        <span className="stop-curse__sub">{bt(babelLang(state), 'cardsStillAllowed')}</span>
        {/* v20 BOLT-097 — every Freeze now drops a ring; leaving it locks you. */}
        {state.freezeZone && (
          <span className="stop-curse__sub" data-testid="freeze-hold-hint">
            Hold in the ring or your cards will lock.
          </span>
        )}
      </div>
      <span className="stop-curse__time">{formatCountdown(left)}</span>
    </div>
  );
}
